import SiteHeader from '@/components/feature/SiteHeader';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const logoUrl = 'https://public.readdy.ai/ai/img_res/8ca5f52e-4f49-4e68-b9b5-aadb0b00df38.png';
  const titreUrl = 'https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/68a33ac7-ff22-4477-a590-bd786eae39af_compressed_titre.webp';
  const photoUrl = 'https://storage.readdy-site.link/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/d0c79a88-511a-4578-8262-3c1c000f04b2_compressed_photo-accueil-site-romudesigner.webp';

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <SiteHeader />

      {/* Contenu central */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-4 md:py-6">
        {/* Titre image au-dessus de la photo */}
        <img
          src={titreUrl}
          alt="Romu Designer Carrelage"
          className="w-full max-w-xs md:max-w-md lg:max-w-lg h-auto object-contain mb-3 md:mb-4"
        />

        {/* Photo avec texte superposé */}
        <div className="relative w-full max-w-4xl">
          <img
            src={photoUrl}
            alt="Romuald Roudaut - artiste carreleur"
            className="w-full h-auto object-contain"
          />
          {/* Texte en bas à droite de la photo */}
          <div
            className="absolute bottom-2 right-2 md:bottom-6 md:right-6 text-right text-white text-sm md:text-xl leading-tight"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}
          >
            <p className="font-black">Romuald Roudaut</p>
            <p className="font-bold italic text-xs md:text-lg">Artiste carreleur</p>
            <p className="text-xs md:text-base text-white/80">romu@romudesigner.fr</p>
          </div>
        </div>

        {/* Tagline sous la photo */}
        <p className="mt-2 md:mt-3 text-center text-2xl md:text-3xl font-heading italic px-4 max-w-full" style={{ letterSpacing: '0.15em' }}>
          Ma seule limite,<br className="md:hidden" /> votre imagination
        </p>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}